import React, { useEffect, useState } from "react";
import { Button, Box, TextField, Menu, MenuItem, IconButton, Tooltip, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import CustomTable from "../../../components/CustomTable";
import { getActivityList } from "../../../services/timesPoint/timesPointActivity";
import Swal from "sweetalert2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import { filterList } from "../../../libs/utils";


const ActivityList = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchKey, setSearchKey] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const columns = [
    { id: "activity", label: "Activity Name", minWidth: 100, align: "left" },
    { id: "desc", label: "Title", minWidth: 100, align: "left" },
    { id: "maxcap", label: "Maxcap", minWidth: 100, align: "left" },
    { id: "points", label: "Points", minWidth: 100, align: "left" },
    { id: "active", label: "Active", minWidth: 100, align: "left" },
    { id: "Action", label: "Action", minWidth: 100, align: "left" },
  ];

  const dataGenerator = (activity) => {
    const points = (activity.pfmDetails || [])
      .map(pfm => `${pfm.pfm}: ${pfm.point}`)
      .join(", ");
    const active = (activity.pfmDetails || [])
      .map(pfm => `${pfm.pfm}: ${pfm.active}`)
      .join(", ");

    return {
      activity: activity.activity,
      desc: activity.desc,
      maxcap: activity.maxcap,
      points,
      active,
      Action: (
        <Link to={`/app/activity/${activity.activity}`} style={{ textDecoration: "none" }}>
          <Button variant="contained" size="small" color="warning">Edit</Button>
        </Link>
      )
    };
  };

  useEffect(() => {
    setLoading(true);
    getActivityList()
      .then((activities) => {
        setLoading(false);
        const rows = (activities.data.data || []).map(dataGenerator);
        setRows(rows);
        console.log("Rows for table:", rows);
      })
      .catch((error) => {
        setLoading(false);
        Swal.fire({
          title: "Oops",
          text: error?.message || "Failed to fetch activities",
          icon: "warning",
          confirmButtonText: "Ok",
        });
      });
  }, []);

  const searchData = (e) => {
    setSearchKey(e.target.value);
  };

  const filteredRows = rows.filter(row =>
    Object.values(row).some(val =>
      String(val).toLowerCase().includes(searchKey.toLowerCase())
    )
  );

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
        <Typography variant="h4">Activities</Typography>
        <div style={{ display: "flex", alignItems: "end" }}>
          <TextField
            id="standard-basic"
            label="Search"
            variant="standard"
            sx={{ mr: 1 }}
            onKeyUp={searchData}
            InputProps={{
              endAdornment: <SearchIcon sx={{ color: "#8a8a8a" }} />,
            }}
          />
          <Tooltip title="Choose Option">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <MoreVertIcon sx={{ width: 32, height: 32 }} />
            </IconButton>
          </Tooltip>
          <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              sx={{
                "&:hover": {
                  background: "#f9da8792",
                  color: "#000",
                },
              }}
            >
              <Link to="/app/activity/0" style={{ color: "#040721" }}>
                Add New Activity
              </Link>
            </MenuItem>
          </Menu>
        </div>
      </Box>
      <CustomTable
          data={filterList(rows, searchKey) || []}
          columns={columns}
        />
    </Box>
  );
};

export default ActivityList;